<template>
    <b-table hover small responsive show-empty class="sr-caption"
             aria-live="polite"
             :fields="attachmentFields"
             :items="items"
             :busy="false"
             label-sort-asc=""
             label-sort-desc=""
             caption="Attachments table.  To sort the data in this table by a specific column,
                           go to the appropriate column header cell and use enter to sort the data ascending.
                           Use enter again to sort descending.">
        <template v-slot:no-data>
            No Attachments Found.
        </template>
        <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle" label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
            <strong>Loading...</strong>
        </div>
        <template v-slot:cell(actions)="row">
            <b-button size="sm" @click="downloadAttachment(row)" target="_attach" class="mr-1">
                Download
            </b-button>
          <b-button v-if="row.item.otherType!=null && row.item.otherType.includes('MDH') && isMDH" size="sm" @click="deleteAttachment(row)" target="_delete" class="mr-1">Delete</b-button>
        </template>
        <template slot="empty" slot-scope="scope">
            No Attachments Found.
        </template>
    </b-table>
</template>

<script>
    import axios from 'axios';
    export default {
        name: "AttachmentList.vue",
        data:()=>({
            attachmentFields:[
                {key:'filename',label:'File Name',sortable:true},
                {key:'type.description',label:'Description',sortable: true},
                {key:'otherType',label:'Other Type',sortable:true},
                {key:'actions',label:'Actions'}
            ]
        }),
        props:{
            items: Array,
            slug:[String],
            isLoading: Boolean,
            isMDH: Boolean,
        },
        methods:{
            downloadAttachment(row){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/getUrl/`+row.item.attachmentId)
                    .then(response=>{
                        if(response.data){
                            window.open(response.data,"_blank");
                        }
                        else{this.$emit('attachment-get-failure')}
                    })
            },
            deleteAttachment(row){
              axios.delete(`${process.env.VUE_APP_API_BASE_URL}/attachments/delete/`+row.item.attachmentId)
                  .then(response=>{
                    this.$emit('attachment-delete-success');
                  })
                  .catch(error=>{
                    this.$emit('attachment-delete-failure');
                  })

            }
        }
    }
</script>

<style scoped>

</style>